import * as $ from 'jquery';
import * as url from 'CMS/core/url';
import SearchPart from 'comex/HeaderParts/SearchPart';
import LoginPart from 'comex/HeaderParts/LoginPart';
import MenuPart from 'comex/HeaderParts/MenuPart';
import SearchControl from 'comex/HeaderParts/SearchControl';

class Header {
    private global: any;
    private layout: any;
    private $risHeader: JQuery;
    private $menuContainer: JQuery;
    private $widgetWrapper: JQuery;

    private $mobileRISHeader: JQuery;    

    constructor(global: any, layout: any) {
        this.global = global;
        this.layout = layout;
    }
    public initialize() {
        console.log("Some icons on this website are provided by https://fontawesome.com/");
        var $root = $('#' + <string>this.layout.r);
        this.$risHeader = $('.ris-header');
        this.$menuContainer = $('.menu-container');

        this.$mobileRISHeader = $('.ris-mobile-header');                

        this.$widgetWrapper = $('.header-pane');
        if (this.$widgetWrapper.length <= 0) {
            this.$widgetWrapper = $('.main-wrapper');
        }

        var $searchRoot = $root.find('.search-container');
        var searchPart = new SearchPart();


        searchPart.initialize({ root: $searchRoot[0] });

        var $menuPart = $root.find('.menu-container');
        var menuPart = new MenuPart();
        menuPart.initialize({ root: $menuPart[0] });


        var $loginRoot = $root.find('.login-part');
        var loginPart = new LoginPart();
        loginPart.initialize({ root: $loginRoot[0], lang: this.global.l });

        /* Language selector */
        this.$risHeader.find('ul.language-list > li').on('click', (e) => {
            var $listItem = $(e.currentTarget);
            this.changeLanguage($listItem.data("code"));
        });
                
        $(window).bind('scroll', ()=> {
            this.checkStick();
        });
        $(window).on('resize', () => {
            this.checkStick();
        });

        /* Mobile header */
        this.$mobileRISHeader.find('#mobile-search-wrapper').on('shown.bs.collapse', () => {            
            this.$mobileRISHeader.find('input.mobile-search-input').focus();
        });

        this.$mobileRISHeader.find('.btn-search').on('click', (e) => {
            location.href = $(e.currentTarget).data('href');
        });

        var $mobileSearchTerm = this.$mobileRISHeader.find('input.mobile-search-input');
        var mobileSearchControl = new SearchControl($mobileSearchTerm.data('searchUrl'), $mobileSearchTerm, null);
        mobileSearchControl.initialize();
        

        this.checkStick();
    }

    private changeLanguage(code: string) {
        if (code !== this.global.l.code) {
            var currentUrl = window.location.href;
            var newUrl = url.updateUrlParameter(currentUrl, 'KL', code);
            window.location.assign(newUrl);
        }
    }

    public checkStick() {
        if ($(window).width() < 992) {
            this.resetStick();
            return;
        }

        var risHeaderHeight = this.$risHeader.outerHeight(true);
        var menuHeight = this.$menuContainer.outerHeight(true);
        
        if ($(window).scrollTop() > risHeaderHeight) {
            this.$menuContainer.addClass('stick');            
            var paddingTop = menuHeight;
            
            this.$widgetWrapper.css('padding-top', paddingTop.toString() + 'px');
        } else {
            this.resetStick();
        }

    }

    //public checkStick() {
    //    var vlHeaderHeight = 37;
    //    var menuHeight = 51;
    //    if ($(window).width() < 992) {
    //        this.resetStick();
    //        return;
    //    }
    //
    //    if ($(window).scrollTop() > 0) {
    //        // stick vl-header
    //        $('.vl-header.stickify').addClass('stick');
    //        $('.main-wrapper').css('padding-top', vlHeaderHeight + 'px');
    //
    //        var risHeaderHeight = $('.ris-header').outerHeight(true);
    //
    //        if ($(window).scrollTop() > risHeaderHeight) {
    //            $('.menu-container').addClass('stick');
    //            var paddingTop = $('.ris-header').outerHeight(true) - menuHeight;
    //            $('.main-wrapper').css('padding-top', paddingTop + 'px');
    //
    //            if ($(window).scrollTop() > risHeaderHeight + menuHeight) {
    //
    //                }
    //        } else {
    //            $('.menu-container').removeClass('stick');
    //            $('.main-wrapper').css('padding-top', vlHeaderHeight + 'px');
    //        }
    //    } else {
    //        this.resetStick();
    //    }
    //
    //
    //    if ($(window).scrollTop() > 181) {
    //        //$('.stickify').addClass('stick');
    //        //$('.stickify-hidden').addClass('stick');
    //        //$('.main-wrapper').addClass('stick-padding');
    //    } else {
    //        //$('.stickify').removeClass('stick');
    //        //$('.stickify-hidden').removeClass('stick');
    //        //$('.main-wrapper').removeClass('stick-padding');
    //    }
    //}

    public resetStick() {
        $('.vl-header.stickify').removeClass('stick');
        $('.menu-container').removeClass('stick');
        this.$widgetWrapper.css('padding-top', '0');
    }
    public destroy() {

    }

}
export = Header;/* Export the class  */


